/* eslint-disable react/forbid-prop-types */
import PropTypes from 'prop-types';
import _ from 'lodash';
import React, { Component } from 'react';
import UCDStatusLabel from './UCDStatusLabel';

const OBJECTIVES = {
  userAcquisition: 'userAcquisition',
  userRetention: 'userRetention',
  userReactivation: 'userReactivation',
  demandGeneration: 'demandGeneration',
  branding: 'branding',
  crossSell: 'crossSell',
  communications: 'communications',
};

const OBJECTIVES_ICON_LABEL = {
  [OBJECTIVES.userAcquisition]: {
    label: 'Acquire New-to-Grab Users',
  },
  [OBJECTIVES.userRetention]: {
    label: 'Retain Lapsing Users',
  },
  [OBJECTIVES.demandGeneration]: {
    label: 'Demand Generation',
  },
  [OBJECTIVES.branding]: {
    label: 'Branding Awareness',
  },
  [OBJECTIVES.communications]: {
    label: 'General Announcements',
  },
  [OBJECTIVES.crossSell]: {
    label: 'Cross-sell',
  },
  [OBJECTIVES.userReactivation]: {
    label: 'Reactivate Churned Users',
  },
};

export default class ProjectSuggestionItem extends Component {
  static propTypes = {
    projectSuggestion: PropTypes.object.isRequired,
    onEnterCallback: PropTypes.func,
    onLeaveCallback: PropTypes.func,
  };
  constructor(props) {
    super(props);
    this.state = {};
  }

  onMouseEnterOption = () => {
    if (typeof this.props.onEnterCallback === 'function') {
      this.props.onEnterCallback();
    }
  };

  onMouseLeaveOption = () => {
    if (typeof this.props.onLeaveCallback === 'function') {
      this.props.onLeaveCallback();
    }
  };

  render() {
    const { projectSuggestion } = this.props;
    const { status, project, createdBy } = projectSuggestion;
    const { name, start, end } = project;
    const objective = _.get(
      OBJECTIVES_ICON_LABEL,
      `${projectSuggestion.project.objective}.label`,
      projectSuggestion.project.objective,
    );
    return (
      <div
        onMouseEnter={this.onMouseEnterOption}
        onMouseLeave={this.onMouseLeaveOption}
      >
        <div>{name}</div>
        <div style={{ color: '#707070' }}>{objective}</div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <div style={{ color: '#707070' }}>{createdBy}</div>
          <div style={{ marginLeft: '10px'}}>
            <UCDStatusLabel
              status={status}
              start={start}
              end={end}
              labelSize={'small'}
            />
          </div>
        </div>
      </div>
    );
  }
}
